import { ControllerClassicOutlineIcon } from './ControllerClassicOutlineIcon';

/**
 * author: Austin Andrews
 * id 053ECCDF-BF30-417F-85D4-FF2614402B5A
 * name controller-classic-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/controller-classic-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const GamepadClassicOutlineIcon = ControllerClassicOutlineIcon;
export default GamepadClassicOutlineIcon